import { LoginDTO } from "@/pages/Login/types";
import { POST } from "./client";
import { useMutation } from "@tanstack/react-query";

export const useLogin = () => {
  return useMutation({
    mutationFn: async (data: LoginDTO) => {
      const response = await POST("/login", data);
      return response;
    },
  });
};
